/**
 * Localization messages for RoleInfo component
 */
import sharedMessages from '../../../shared/messages/sharedMessages';
import { mergeInvertedMessages } from '../../../utils/localization';

const componentMessages = {
  // Component-specific messages
  'Role Name': 'roleRecs.roleInfo.roleNameLabel',
  'Enter role name': 'roleRecs.roleInfo.roleNamePlaceholder',
  'Enter role description': 'roleRecs.roleInfo.roleDescriptionPlaceholder',
} as const;

const invertedMessages = mergeInvertedMessages(
  sharedMessages,
  componentMessages
);

export type RoleInfoMessage = keyof typeof invertedMessages;

export default invertedMessages;
